export function createClassWithSuffix(classPrefix: string, suffix: string | number): string {
	if (classPrefix.includes('%s')) {
		return classPrefix.replace('%s', suffix.toString());
	}
	return classPrefix;
}
